var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecieptColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .recieptColored1,.recieptColored2{fill:none;stroke:#8c8d99;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}.recieptColored2{stroke:#1bc47d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_receipt-text",
    "data-name": "vuesax/twotone/receipt-text",
    transform: "translate(-108 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "recieptColored1",
    d: "M6 4v2.42A2.4 2.4 0 0 1 3.42 9H0V2.01A2.019 2.019 0 0 1 2.02 0 3.995 3.995 0 0 1 6 4z",
    transform: "translate(124 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    className: "recieptColored1",
    d: "M0 5v14a1 1 0 0 0 1.6.8l1.71-1.28a1.007 1.007 0 0 1 1.32.1l1.66 1.67a1.008 1.008 0 0 0 1.42 0l1.68-1.68a.991.991 0 0 1 1.3-.09l1.71 1.28A1 1 0 0 0 14 19V2a2.006 2.006 0 0 1 2-2H4C1 0 0 1.79 0 4z",
    transform: "translate(110 446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    className: "recieptColored2",
    d: "M0 0h6",
    transform: "translate(114 453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    className: "recieptColored2",
    d: "M0 0h4.5",
    transform: "translate(114.75 457)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecieptColored);
export default __webpack_public_path__ + "static/media/reciept-colored.c1dc90823ad4e7ea3ac6628d9c67291e.svg";
export { ForwardRef as ReactComponent };